// StepProgress.tsx
import React from "react";
import { fontGreyColor, mobileChangeWidth } from "../../../styles/theme";
import { StepImg, StepLabel } from "./style";

interface Step {
    label: string;
    activeImg: string;
    inactiveImg: string;
}

interface StepProgressProps {
    steps: Step[];
    current: number; // 0부터 시작 (현재 활성화된 step index)
    activeColor?: string;
    inactiveColor?: string;
}
// @media only screen and (max-width: ${mobileChangeWidth}) {
//     max-height: 70vh;
//     overflow: auto;
//   }
export default function StepProgress({
    steps,
    current,
    activeColor = "#222",
    inactiveColor = fontGreyColor,
}: StepProgressProps) {
    return (
        <div style={{ display: "flex", alignItems: "start", width: "100%", maxWidth: "800px", margin: "0 auto" }}>
            {steps.map((step, idx) => (
                <React.Fragment key={step.label}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                        <StepImg
                            src={idx === current ? step.activeImg : step.inactiveImg}
                            alt={idx === current ? "active" : "inactive"}
                        />
                        <StepLabel
                            color={idx === current ? activeColor : inactiveColor}
                            fontWeight={idx === current ? "500" : "400"}
                            fontSize="20px"
                        >
                            {step.label}
                        </StepLabel>
                    </div>
                    {/* 마지막 step이 아니면 선 추가 */}
                    {idx < steps.length - 1 && (
                        <div style={{ flex: 1, display: "flex", alignItems: "center", height: "22px" }}>
                            <div style={{ width: "100%", height: "1px", background: "#e0e0e0", alignSelf: "center" }} />
                        </div>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}